<template lang="pug">
.details
  .details__spec 
    span {{ label }}
  .details__content
    TransitionToggle
      AppDetail(v-for="product, i in products", :key="i", :detail="product.specs[spec]")
  
</template>

<script>
import AppDetail from './Detail.vue'
import TransitionToggle from '../transitions/Toggle.vue'
import { mapGetters } from 'vuex'
export default {
  name: "AppDetails",
  components: {
    AppDetail,
    TransitionToggle
  },
  props: [
    'spec',
    'label'
  ],
  computed: {
    ...mapGetters(['products']),
  }
}
</script>

<style lang="scss" scoped>
.details {
  @include fluid(font-size, 0.75rem, 1rem, 320px, 991px);
  display: contents;

  &:hover {

    .details__spec,
    &::v-deep .detail {
      &::after {
        opacity: 1;
      }
    }
  }

  .details__spec,
  &::v-deep .detail {
    display: flex;
    position: relative;
    cursor: default;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(darken($lightGray, 30%), 0.15);
      z-index: 1;
      opacity: 0;
      transition: 0.2s ease;
    }
  }

  &__spec {
    @include fontHeadings;
    @include cell(true);

    span {
      z-index: 2;
    }
  }

  &__content {
    display: flex;
    grid-column: 2 / 3;
    grid-row: span 1;
  }
}
</style>